module.exports = __webpack_public_path__ + "img/Frage1_1024x768.669fb423.jpg";